import { useSelector, useDispatch } from 'react-redux';
import { loginStart, loginSuccess, loginFailure, logout } from '../store/slices/authSlice';
import { login as apiLogin } from '../services/auth';

export const useAuth = () => {
  const dispatch = useDispatch();
  const { user, token, isLoading, error } = useSelector((state) => state.auth);

  const login = async (email, password) => {
    dispatch(loginStart());
    try {
      const data = await apiLogin(email, password);
      dispatch(loginSuccess({ user: data.user, token: data.token }));
      return true;
    } catch (err) {
      dispatch(loginFailure(err.response?.data?.error || 'Login failed'));
      return false;
    }
  };

  const logoutUser = () => {
    dispatch(logout());
  };

  const isAuthenticated = !!token && !!user;

  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout: logoutUser,
  };
};